import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormHeader from 'components/molecules/formHeader';
import FormCol from 'components/molecules/formCol';
import FormTextField from 'components/molecules/formTextField/index.jsx';
import FormCardSelectField from 'components/molecules/formCardSelectField';
import ExplainedCheckbox from 'components/molecules/explainedCheckbox';
import Loader from 'components/atoms/loader';
import WizardProgress from 'components/organisms/wizard/progress';
import CollapsableSelectList from 'components/organisms/collapsableSelectList';
import CollapsableSelectListItem from 'components/molecules/collapsableSelectListItem';

import includes from 'helpers/string/includes';
import validate from '../validate';

class VehicleSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  setSearch(e) {
    this.setState({
      search: e.target.value,
    });
  }

  render() {
    const { handleSubmit, onVehicleSelect, brand } = this.props;

    return (
      <div className="vehicleSelect">
        <Header inFlow />

        <WizardProgress step="1" />

        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Selecciona tu vehículo</h2>
              <p className="m">Para brindarte un mejor servicio, necesitamos algunos detalles.</p>
              <form onSubmit={handleSubmit}>
                <FormContent nomargins>
                  <FormHeader>
                    <FormTextField
                      type="text"
                      placeholder="Buscar"
                      size="full"
                      onChange={this.setSearch.bind(this)}
                      noborder
                      icon="search"
                      meta={{}}
                    />
                  </FormHeader>

                  <FormCol single scrolleable cardList>
                    {this.props.isFetching && <Loader />}

                    {this.props.models.length === 0 && !this.props.isFetching && (
                      <div>
                        Todavía no hay vehículos disponibles para seleccionar. Por favor intentá
                        nuevamente en otro momento.
                        <p>
                          <a href="http://www.territorioyacopini.com.ar">Territorio Yacopini</a>
                        </p>
                      </div>
                    )}

                    {this.props.models.map((model, i) => {
                      if (this.state.search && includes(this.state.search, model.name) === false) {
                        return null;
                      }

                      return (
                        <Field
                          key={i}
                          name="vehicle"
                          component={FormCardSelectField}
                          props={{ fieldValue: model, onChange: onVehicleSelect }}
                        >
                          <div>
                            <h5>{model.name}</h5>
                            {model.image && <img src={model.image} alt={model.name} />}
                          </div>
                        </Field>
                      );
                    })}
                  </FormCol>

                  <FormActions>
                    {brand !== 'vw' && (
                      <CollapsableSelectList onFormActions>
                        <CollapsableSelectListItem>
                          <Field
                            component={ExplainedCheckbox}
                            name="public_use"
                            props={{
                              title: 'Mi vehículo es de uso comercial',
                              helpText:
                                'Si no marcas esta casilla, significa que el vehículo es de uso particular',
                              fieldValue: true,
                              toggleValue: false,
                            }}
                          />
                        </CollapsableSelectListItem>
                      </CollapsableSelectList>
                    )}
                    <Button disabled={!this.props.vehicle} type="submit" buttonText="Continuar" />
                  </FormActions>
                </FormContent>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

VehicleSelect = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(VehicleSelect);

const selector = formValueSelector('shiftRequest');

VehicleSelect = connect(state => {
  const vehicle = selector(state, 'vehicle');
  return {
    vehicle,
    brand: state.configuration.brand,
  };
})(VehicleSelect);

export default VehicleSelect;
